import React from "react";
import HomeComp from "../components/home/HomeComp";

const Home = () => {
  return (
    <>
      <HomeComp />
    </>
  );
};
export default Home;
